import React from 'react';

const EnvironmentBanner: React.FC = () => {
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
  const isProduction = environment === 'production';
  const isStaging = environment === 'staging';
  const isDevelopment = environment === 'development';

  // Don't show banner in production unless explicitly configured
  if (isProduction && !import.meta.env.VITE_SHOW_ENV_BANNER) {
    return null;
  }

  // Don't show banner in development
  if (isDevelopment) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-center py-1 px-4 text-xs font-medium text-white/90 z-50 relative tracking-wide">
      BETA &mdash; Demo environment with sample data
    </div>
  );
};

export default EnvironmentBanner;